import { ApolloError } from "@apollo/client";
import { useMemo } from "react";

import { ISelectOption } from "src/core/constants/options";
import { useLegalStatusListPphQuery } from "src/core/gql/graphql";

export const useLegalStatusOptionsPPH = (): {
  legalStatusOptions: ISelectOption[];
  loading: boolean;
  error: ApolloError | undefined;
} => {
  const { data: legalStatusListPph, loading, error } = useLegalStatusListPphQuery();

  const legalStatusOptions: ISelectOption[] = useMemo(() => {
    return (
      legalStatusListPph?.listElements?.map((legalStatus) => ({
        value: legalStatus.code,
        label: legalStatus.name,
      })) ?? []
    );
  }, [legalStatusListPph]);

  return { legalStatusOptions, loading, error };
};
